module.exports = __webpack_public_path__ + "img/STERiJECT_04.7148d64f.png";